import request from './xy.js'

export function GETRECOMMENDWEDXY (data) {
	return request({
		url: 'gbca/sys/getRecommendWed',
		method: 'POST',
		data: data,
		// header: {
		// 	'gsToken': data.token
		// }
	})
}

// 鉴定查询结果
export function GetRatingInfoXY (data) {
	return request({
		url: '/gbca/orderCoin/getWebsiteRatingInfo',
		method: 'post',
		data: data
	});
}

export function SEARCHCHECKURLXY(data) { //鉴定查询-验证评级编号加密规则
	return request({
		url: 'gbca/sys/searchCheckUrl',
		method: 'POST',
		data: data,
	})
}


// WEBPACK FOOTER //
// ./src/api/xyapi.js